import React, {useEffect, useState} from "react";
import {Col, Row, Select} from "antd";
import {
    DateRangeFilter,
    SearchText,
    DateFilter
} from "../../../_defaultComponents/FilterComponents";
import {useHistory} from "react-router-dom";
import moment from "moment";

const Filters = ({filters, setFilters}) => {
    const history = useHistory();
    const [groupName, setGroupName] = useState(filters.groupName);
    const [shipmentNumber, setShipmentNumber] = useState(filters.shipmentNumber);
    const defaultDateRange = [moment().subtract(30, "days"), moment()];
    const [cutOffDateRange, setCutOffDateRange] = useState(defaultDateRange);
    const [date, setDate] = useState(filters.date);
    const [transferCenter, setTransferCenter] = useState(filters.transferCenter);
    const [groupStatus, setGroupStatus] = useState(filters.groupStatus);
    const [warehouseStatus, setWarehouseStatus] = useState(filters.warehouseStatus);
    const [deliveryStatus, setDeliveryStatus] = useState(filters.deliveryStatus);
    const [missingStatus, setMissingStatus] = useState(filters.missingStatus);

    const handleUrlSearchParam = () => {
        const urlSearchParams = new URLSearchParams(window.location.search);

        const urlGroupName = urlSearchParams.get("groupName");
        const urlShipmentNumber = urlSearchParams.get("shipmentNumber");
        const urlStartDate = urlSearchParams.get("startDate");
        const urlEndDate = urlSearchParams.get("endDate");
        const urlDate = urlSearchParams.get("date");
        const urlTransferCenter = urlSearchParams.get("transferCenter");
        const urlGroupStatus = urlSearchParams.get("groupStatus");
        const urlWarehouseStatus = urlSearchParams.get("warehouseStatus");
        const urlDeliveryStatus = urlSearchParams.get("deliveryStatus");
        const urlMissingStatus = urlSearchParams.get("missingStatus");

        if (urlGroupName) setGroupName(urlGroupName);
        if (urlShipmentNumber) setShipmentNumber(urlShipmentNumber);
        if (urlStartDate && urlEndDate) {
            setCutOffDateRange([moment(urlStartDate), moment(urlEndDate)]);
        }
        if (urlDate) setDate(moment(urlDate));
        if (urlTransferCenter) setTransferCenter(urlTransferCenter);
        if (urlGroupStatus) setGroupStatus(urlGroupStatus);
        if (urlWarehouseStatus) setWarehouseStatus(urlWarehouseStatus);
        if (urlDeliveryStatus) setDeliveryStatus(urlDeliveryStatus);
        if (urlMissingStatus) setMissingStatus(urlMissingStatus);
    };

    const setUrl = () => {
        let path = history?.location?.pathname;
        path += "?";

        if (groupName) {
            path += "groupName=" + encodeURIComponent(groupName);
        }
        if (shipmentNumber) {
            path += "&shipmentNumber=" + encodeURIComponent(shipmentNumber);
        }
        if (cutOffDateRange?.length === 2) {
            path += "&startDate=" + moment(cutOffDateRange[0]).format("YYYY-MM-DD");
            path += "&endDate=" + moment(cutOffDateRange[1]).format("YYYY-MM-DD");
        }
        if (date) {
            path += "&date=" + moment(date).format("YYYY-MM-DD");
        }
        if (transferCenter) {
            path += "&transferCenter=" + transferCenter;
        }
        if (groupStatus) {
            path += "&groupStatus=" + groupStatus;
        }
        if (warehouseStatus) {
            path += "&warehouseStatus=" + warehouseStatus;
        }
        if (deliveryStatus) {
            path += "&deliveryStatus=" + deliveryStatus;
        }
        if (missingStatus) {
            path += "&missingStatus=" + missingStatus;
        }

        history.push(path);
    };

    useEffect(() => {
        handleUrlSearchParam();
    }, []);

    useEffect(() => {
        const newFilters = {
            ...filters,
            groupName,
            shipmentNumber,
            cutOffDateRange,
            date,
            transferCenter,
            groupStatus,
            warehouseStatus,
            deliveryStatus,
            missingStatus
        };

        if (JSON.stringify(filters) !== JSON.stringify(newFilters)) {
            setFilters(newFilters);
            setUrl();
        }
    }, [
        groupName,
        shipmentNumber,
        cutOffDateRange,
        date,
        transferCenter,
        groupStatus,
        warehouseStatus,
        deliveryStatus,
        missingStatus
    ]);

    return (
        <Row gutter={[16, 16]} style={{marginBottom: "12px", display: "flex", gap: "12px"}}>
            <Col xs={24} sm={24} md={12} lg={5} xl={4}>
                <SearchText
                    style={{width: "200px"}}
                    label="Transfer Grubu"
                    value={groupName}
                    onChange={setGroupName}
                />
            </Col>
            <Col xs={24} sm={24} md={12} lg={5} xl={4}>
                <SearchText
                    style={{width: "200px"}}
                    label="Paket Numarası"
                    value={shipmentNumber}
                    onChange={setShipmentNumber}
                />
            </Col>
            <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                <DateRangeFilter
                    style={{width: "200px"}}
                    label="Cutoff Tarih Aralığı"
                    onChange={value => setCutOffDateRange(value)}
                    value={cutOffDateRange}
                />
            </Col>
            <Col xs={24} sm={24} md={12} lg={3}>
                <DateFilter value={date} onChange={setDate} showAllOption={false} allowClear />
            </Col>
            <Col xs={24} sm={24} md={12} lg={4}>
                <h5>Transfer Merkezi</h5>
                <Select
                    title="Transfer Merkezi"
                    placeholder="Transfer Merkezi"
                    style={{width: "100%"}}
                    onChange={value => setTransferCenter(value)}
                    allowClear
                    value={transferCenter}
                >
                    {filters.transferCenters?.result?.map(center => (
                        <Select.Option key={center._id} value={center._id}>
                            {center.name}
                        </Select.Option>
                    ))}
                </Select>
            </Col>
            <Col xs={24} sm={24} md={12} lg={4}>
                <h5>Transfer Grubu Durumu</h5>
                <Select
                    style={{width: "100%"}}
                    value={groupStatus}
                    onChange={setGroupStatus}
                    allowClear
                >
                    <Select.Option value="created">Oluşturuldu</Select.Option>
                    <Select.Option value="closed">Gün Kapandı</Select.Option>
                </Select>
            </Col>
            <Col xs={24} sm={24} md={12} lg={4}>
                <h5>Depodan Teslim Durumu</h5>
                <Select
                    style={{width: "100%"}}
                    value={warehouseStatus}
                    onChange={setWarehouseStatus}
                    allowClear
                >
                    <Select.Option value="fullyReceived">Tam Teslim Alındı</Select.Option>
                    <Select.Option value="partiallyReceived">Kısmi Teslim Alındı</Select.Option>
                    <Select.Option value="notReceived">Teslim Alınmadı</Select.Option>
                </Select>
            </Col>
            <Col xs={24} sm={24} md={12} lg={4}>
                <h5>Teslimat Durumu</h5>
                <Select
                    style={{width: "100%"}}
                    value={deliveryStatus}
                    onChange={setDeliveryStatus}
                    allowClear
                >
                    <Select.Option value="fullyDelivered">Tam Teslim Edildi</Select.Option>
                    <Select.Option value="partiallyDelivered">Kısmi Teslim Edildi</Select.Option>
                    <Select.Option value="notDelivered">Teslim Edilmedi</Select.Option>
                </Select>
            </Col>
            <Col xs={24} sm={24} md={12} lg={4}>
                <h5>Kayıp Durumu</h5>
                <Select
                    style={{width: "100%"}}
                    value={missingStatus}
                    onChange={setMissingStatus}
                    allowClear
                >
                    <Select.Option value="fullyMissing">Tamamen Kayıp</Select.Option>
                    <Select.Option value="partiallyMissing">Kısmi Kayıp</Select.Option>
                    <Select.Option value="notMissing">Kayıp Yok</Select.Option>
                </Select>
            </Col>
        </Row>
    );
};

export default Filters;
